import React from 'react';
import { Divider as HorizontalLine } from '@mui/material';

function Divider(props) {
    return (
        <div className="w-full pt-64 pb-48" {...props}>
            <HorizontalLine />
        </div>
    );
}

export default Divider;
